import { useMemo } from 'react';

/**
 * The API origin the widget addresses, from the page's location.
 *
 * A pure function rather than only a hook so code that runs before any React
 * tree exists -- the demo bundle's token resolution (item #17619) -- resolves
 * the same origin the mounted widget will query. Two implementations of this
 * rule would be two places for them to disagree.
 *
 * @param {{hostname: string}|undefined} location - window.location, or
 *   undefined outside a browser
 * @returns {string} '' for same-origin on dev hosts, the production origin
 *   otherwise
 */
export function resolveBaseUrl(location) {
  if (!location) {
    // During SSR, default to production URL
    return 'https://visitingobjects.com';
  }

  const { hostname } = location;

  // Determine if we're in development (localhost, ts.net, or ngrok tunnels) or production
  const isDev =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.ts.net') ||
    hostname.endsWith('.ngrok-free.dev') ||
    hostname.endsWith('.ngrok.io') ||
    hostname.endsWith('.ngrok.app');

  // Set the base URL based on environment
  if (isDev) {
    return '';
  }

  // For production, use visitingobjects.com
  return 'https://visitingobjects.com';
}

export const use_base_url = () => {
  return useMemo(() => {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
      return resolveBaseUrl(undefined);
    }
    return resolveBaseUrl(window.location);
  }, []);
};
